/* @ngInject */
const accountButtons = (
  labels,
  icons,
  toaster,
  userService
) => {
  const self = {}

  const askDelete = (_account) => {
    if (toaster.confirm('Êtes-vous sûr de vouloir supprimer le compte ' + _account.username)) {
      userService.delete(_account)
    }
  }

  self.delete = {
    labels: labels.delete,
    icon: icons.delete,
    action: askDelete,
    display: (_nature) => {
      return true
    },
    class: (_area) => {
      return 'retour'
    },
  }

  return self
}
export default accountButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/resources/buttons.resource.js